export default "__VITE_ASSET__9441fd4f__"